import { useOrganization } from '@proton/account/organization/hooks';
import { FeatureCode } from '@proton/features/interface';
import useFeature from '@proton/features/useFeature';
import { selectActiveCategoriesTabs, selectCategoriesLabel } from '@proton/mail/store/labels/selector';
import { useMailSettings } from '@proton/mail/store/mailSettings/hooks';
import { useSelector } from '@proton/redux-shared-store/sharedProvider';
import { useFlagsStatus } from '@proton/unleash/proxy';
import { useFlag } from '@proton/unleash/useFlag';

export const useCategoriesData = () => {
    const [mailSettings, mailSettingsLoading] = useMailSettings();
    const [organization, organizationLoading] = useOrganization();

    const categoryViewFlag = useFlag('CategoryView');
    const { flagsReady } = useFlagsStatus();
    const betaFlag = useFeature<boolean>(FeatureCode.CategoryViewBeta);
    const hasBetaAccess = betaFlag.feature?.Value ?? false;

    const categoriesStore = useSelector(selectCategoriesLabel);
    const activeCategoriesTabs = useSelector(selectActiveCategoriesTabs);

    const canUseCategoryView = categoryViewFlag || hasBetaAccess;
    const settingAccess = organization?.Settings?.MailCategoryViewEnabled ? !!mailSettings.MailCategoryView : false;
    const isCategoryViewEnabled = canUseCategoryView && settingAccess;

    const isRefreshedToolbarUIDisabled = useFlag('NewToolbarKillSwitch');
    const shouldSeeWideToolbars = canUseCategoryView ? !isRefreshedToolbarUIDisabled : false;

    // Redirect decisions must wait until every input behind `categoryViewAccess` has loaded.
    const isCategoryViewEnabledSettled =
        !mailSettingsLoading && !organizationLoading && !betaFlag.loading && flagsReady;

    return {
        canUseCategoryView,
        categoriesStore,
        activeCategoriesTabs: isCategoryViewEnabled ? activeCategoriesTabs : [],
        isCategoryViewEnabled,
        isCategoryViewEnabledSettled,
        shouldSeeWideToolbars,
    };
};
